import { render, staticRenderFns } from "./widgetAscDesc.vue?vue&type=template&id=682ad837&scoped=true"
import script from "./widgetAscDesc.vue?vue&type=script&lang=js"
export * from "./widgetAscDesc.vue?vue&type=script&lang=js"
import style0 from "./widgetAscDesc.vue?vue&type=style&index=0&id=682ad837&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682ad837",
  null
  
)

export default component.exports